import React, {
	useState,
} from 'react';

import CustomIcon from 'Crow/Form/Field/Custom/Common/CustomIcon/CustomIcon.js';

import style from 'Vulture/View/Sidebar.module.css';

import {
	hasPermission,
	isInitialized,
} from 'Vulture/Permissions.js';
import {
	dlNavigationPush,
} from 'Vulture/DataLayer';
import {
	buildTestData, removeWhitespace,
} from 'Vulture/TestData';
import {
	useVisualContentLoopContext,
} from 'Crow/Form/Field/Custom/Vulture/VisualContentLoopContext';
import {
	handlePendingChangesNavigation,
} from 'Vulture/lib/Nav';
import {
	SIDEBAR_ITEMS, ADMIN_ITEMS,
} from 'Vulture/View/navItems';

const SidebarView = (props) => {
	const [ sidebarClass, setSidebarClass, ] = useState('collapsed');

	const {
		app,
		accountUUID,
		isVCLEnabled,
		classNameList,
	} = props;

	const {
		router,
	} = app.props;

	const {
		mode,
		account,
	} = router.params;

	const vclContext = useVisualContentLoopContext();

	// Base + admin nav items come from the shared canonical definition (Vulture/View/
	// navItems.js) so the sidebar and the account-switch access guard in App.js can't drift.
	let sidebarItems = SIDEBAR_ITEMS;

	if (!isVCLEnabled) {
		const filteredNames = [ 'visual_content_loop', 'slide_deck', ];
		sidebarItems = sidebarItems.filter((item) => {
			return !filteredNames.includes(item.name);
		});
	}

	const adminItems = ADMIN_ITEMS;

	// If permissions are not yet initialized, show a loading state
	if (!isInitialized()) {
		return (
			<div id="sidebar" className={`${style.sidebar} ${style.collapsed} ${style.loading}`}>
				<div className={style.loadingIndicator}>
					<CustomIcon icon="spinner" spin={true} />
				</div>
			</div>
		);
	}

	// Filter items based on permissions
	const allMenuItems = [ ...sidebarItems, ...adminItems, ];
	const visibleMenuItems = allMenuItems.filter((item) => {
		const hasPerm = hasPermission(item.permission);

		return hasPerm;
	});

	let sidebarCondition = style.disabled;

	if (visibleMenuItems.some((item) => {
		return item.name === mode;
	}) || accountUUID) {
		sidebarCondition = '';
	}

	return (
		<div id="sidebar" className={`${style.sidebar} ${style[sidebarClass]} ${sidebarCondition} ${(classNameList || []).join(' ')}`}
			onMouseEnter={(e) => {
				if (mode !== 'accounts') {
					e.preventDefault();
					setSidebarClass('expanded');
				}
			}}
			onMouseLeave={(e) => {
				e.preventDefault();
				setSidebarClass('collapsed');
			}}
		>
			<ul className={style.menu}>
				{visibleMenuItems.map((item, i) => {
					return (
						<li
							className={mode === item.name ? `${style.active}` : ''}
							key={`sidebarItem_${i}`}
							value={i}
							data-test-id={`sidebarItem${removeWhitespace(item.label)}`}
							data-testing-info={buildTestData(`listItem--${removeWhitespace(item.label)}`)}
							onClick={(e) => {
								e.preventDefault();

								dlNavigationPush({
									destination: item.label,
								});

								let handleClick = () => {
									if (item.name === 'visual_content_loop' && mode === 'visual_content_loop' && typeof window.__vclReset === 'function') {
										window.__vclReset();
									}
									setSidebarClass('collapsed');

									let path = `/${item.name}`;
									if (account) {
										path = `/${item.name}/${account}`;
									}

									app.redirect({
										to: path,
									});
								};

								handlePendingChangesNavigation(app, handleClick, vclContext);
							}}
							data-onclick={item.label}
						>
							<div className={style.icon}>
								<CustomIcon icon={item.icon} />
							</div>
							<div className={style.name}>{item.label}</div>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default SidebarView;